import apiService from "./apiService";

const eventService = {
    async search(searchParams) {
        try {
            return (await apiService.get(`contest/search`, searchParams, true)).data;
        }
        catch {
            return [];
        }
    },
    async resetScores(id) {
        try {
            return (await apiService.put(`contest/initialize-scores/${id}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getInfo(id) {
        try {
            return (await apiService.get(`contest/get-contest-byid/${id}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async deleteEvent(id) {
        try {
            return (await apiService.post(`contest/delete-event/${id}`, {}, true)).data;
        }
        catch {
            return {success: false, message: "An error occured while processing the request."};
        }
    },
    async saveContest(contest) {
        try {
            return (await apiService.post(`contest/savecontest/`, contest, true)).data;
        }
        catch {
            return [];
        }
    },
}

export default  eventService;